import { lazy } from "react";

import {
  AccountInfo,
  AuthSettings,
  PageSelection,
  PayoutSettings,
  Team,
} from "./accountSettings";

const Dashboard = lazy(() => import("./Dashboard"));
const ScheduledDeletion = lazy(() => import("./ScheduledDeletion"));

export {
  AccountInfo,
  AuthSettings,
  Dashboard,
  PageSelection,
  PayoutSettings,
  ScheduledDeletion,
  Team,
};
